module.exports = __webpack_public_path__ + "static/1329039896.588d1fc7.jpg";